<script>
export default {
  name: "settingsDepartmentIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.0007 4.77332C11.9607 4.76665 11.914 4.76665 11.874 4.77332C10.954 4.73998 10.2207 3.98665 10.2207 3.05331C10.2207 2.09998 10.9874 1.33331 11.9407 1.33331C12.894 1.33331 13.6607 2.10665 13.6607 3.05331C13.654 3.98665 12.9207 4.73998 12.0007 4.77332Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3149 9.62663C12.2283 9.77997 13.2349 9.61996 13.9416 9.14663C14.8816 8.51996 14.8816 7.4933 13.9416 6.86663C13.2283 6.3933 12.2083 6.23329 11.2949 6.39329"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.98031 4.77332C4.02031 4.76665 4.06698 4.76665 4.10698 4.77332C5.02698 4.73998 5.76031 3.98665 5.76031 3.05331C5.76031 2.09998 4.99365 1.33331 4.04031 1.33331C3.08698 1.33331 2.32031 2.10665 2.32031 3.05331C2.32698 3.98665 3.06031 4.73998 3.98031 4.77332Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.6676 9.62663C3.75427 9.77997 2.7476 9.61996 2.04094 9.14663C1.10094 8.51996 1.10094 7.4933 2.04094 6.86663C2.75427 6.3933 3.77427 6.23329 4.6876 6.39329"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.0007 9.75336C7.9607 9.74669 7.91404 9.74669 7.87404 9.75336C6.95404 9.72002 6.2207 8.96669 6.2207 8.03336C6.2207 7.08002 6.98737 6.31335 7.9407 6.31335C8.89403 6.31335 9.6607 7.08669 9.6607 8.03336C9.65404 8.96669 8.9207 9.72669 8.0007 9.75336Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.06047 11.8534C5.12047 12.48 5.12047 13.5067 6.06047 14.1334C7.12714 14.8467 8.8738 14.8467 9.94047 14.1334C10.8805 13.5067 10.8805 12.48 9.94047 11.8534C8.88047 11.1467 7.12714 11.1467 6.06047 11.8534Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped></style>
